import { createRouter, createWebHistory } from 'vue-router';
import AIMode from '../views/AIMode.vue';
import store from '../store';

// 预加载组件
const PreMatch = () => import('../views/PreMatch.vue');
const CRoom = () => import('../views/CRoom.vue');
const NotFound = () => import('../views/NotFound.vue');

const routes = [
  {
    path: '/',
    redirect: '/aimode'
  },
  {
    path: '/aimode',
    name: 'AIMode',
    component: AIMode
  },
  {
    path: '/pre-match',
    name: 'PreMatch',
    component: PreMatch,
    meta: { requiresAuth: true }
  },
  {
    path: '/croom',
    name: 'CRoom',
    component: CRoom,
    meta: { requiresAuth: true }
  },
  {
    path: '/vip',
    name: 'VIP',
    component: AIMode, // 使用AIMode作为底层组件
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      // 显示VIP模态框
      window.dispatchEvent(new CustomEvent('show-vip-modal'));
      next();
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// 导航守卫，检查认证
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isLoggedIn = store.getters.isLoggedIn;

  if (requiresAuth && !isLoggedIn) {
    // 触发登录模态窗口的显示
    window.dispatchEvent(new CustomEvent('show-login-modal'));
    next(false);
  } else {
    next();
  }
});

export default router;
